import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleModal } from '../store/actions/toggleModalActions';
import { addCompany, editCompany, blockCompany } from '../store/actions/companiesActions';
import './CompanyModal.scss';

const selector = state => {
    const { language, disableButtons, companies } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        selected: companies.selected
    }
};

const CompanyModal = props => {
    const { company, numberPerPage, filter, edit } = props;
    const { t, disableButtons, selected } = useSelector(selector);
    const dispatch = useDispatch();

    const [name, setName] = useState(company ? company.name : '');
    const [address, setAddress] = useState(company ? company.address : '');
    const [vatNumber, setVatNumber] = useState(company ? company.vatNumber : '');
    const [blockConfirmation, setBlockConfirmation] = useState(false);

    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    const handleAddCompanyClick = () => {
        const companyData = {
            name,
            address,
            vatNumber,
            isBlocked: false
        };

        dispatch(addCompany(companyData));

        closeModal();
    };

    const handleEditCompanyClick = () => {
        const companyData = {
            id: company.id,
            name,
            address,
            vatNumber,
            isBlocked: company.isBlocked
        };

        dispatch(editCompany(companyData, selected.page));

        closeModal();
    };

    const handleBlockCompanyClick = () => {
        setBlockConfirmation(!blockConfirmation)
    };

    const confirmBlockCompanyClick = id => {
        dispatch(blockCompany(id, selected.page, numberPerPage, filter));
        closeModal();
    };

    return (
        <div
            className='companyModalBlur'
            onClick={e => {
                if(e.target.className === 'companyModalBlur') {
                    closeModal()
                }
            }}
        >
            <div className='companyModal'>
                <div className='companyModalHeader'>
                    <div className='companyModalTitleContainer'>
                        <div className='companyModalTitle'>
                            {t.gettext('Company details')}
                        </div>
                    </div>
                    <div className='companyModalCloseButtonHolder'>
                        <span
                            className='material-icons companyModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div className='companyModalContent'>
                    <form className='companyModalForm' autoComplete='off'>

                        {(edit && !company.isBlocked) &&
                            <div className='companyButtonsHolder'>
                                <button
                                    className='companyAddButton companyDeleteButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleBlockCompanyClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Block Company')}
                                </button>
                            </div>
                        }

                        {blockConfirmation &&
                            <div className='companyBlockConfirmation'>
                                {company.name + ' ' + t.gettext('will be blocked')}
                                <button
                                    className='confirmationButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        confirmBlockCompanyClick(company.id);
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('OK')}
                                </button>
                                <button
                                    className='confirmationButton confirmationButton--cancel'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleBlockCompanyClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Cancel')}
                                </button>
                            </div>
                        }

                        <div className='companyModalFormItem'>
                            <label className='companyModalFormLabel'>
                                {t.gettext('Name')}
                            </label>
                            <input
                                className='companyModalFormInput'
                                defaultValue={company ? company.name : ''}
                                onInput={e => {
                                    setName(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        <div className='companyModalFormItem'>
                            <label className='companyModalFormLabel'>
                                {t.gettext('Address')}
                            </label>
                            <input
                                className='companyModalFormInput'
                                defaultValue={company ? company.address : ''}
                                onInput={e => {
                                    setAddress(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        <div className='companyModalFormItem'>
                            <label className='companyModalFormLabel'>
                                {t.gettext('VAT Number')}
                            </label>
                            <input
                                className='companyModalFormInput'
                                defaultValue={company ? company.vatNumber : ''}
                                onInput={e => {
                                    setVatNumber(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        {edit &&
                            <div className='companyModalFormItem'>
                                <label className='companyModalFormLabel'>
                                    {t.gettext('Is Active')}
                                </label>
                                <div className='companyModalFormInput'>
                                    {!company ? '' : !company.isBlocked
                                        ? <span
                                            className='material-icons iconTrue'
                                        >
                                            check_circle
                                        </span>
                                        : <span
                                            className='material-icons iconFalse'
                                        >
                                            cancel
                                        </span>
                                    }
                                </div>
                            </div>
                        }

                        <div className='companyButtonsHolder'>
                            <button
                                className='companyAddButton'
                                onClick={e => {
                                    e.preventDefault();
                                    edit ? handleEditCompanyClick() : handleAddCompanyClick();
                                }}
                                disabled={disableButtons}
                            >
                                {edit ? t.gettext('Update Company') : t.gettext('Add Company')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CompanyModal;
